export const translations = {
  en: {
    loginTitle: "Corporate Access",
    accessCode: "Access Code",
    loginBtn: "Enter Platform",
    invalidCode: "Invalid access code. Please try again.",
    dashboard: "Dashboard",
    clients: "Clients",
    settings: "Settings",
    logout: "Logout",
    totalClients: "Total Clients",
    totalWebsites: "Tracked Websites",
    totalKeywords: "Keywords Tracked",
    recentActivity: "Platform Overview",
    addClient: "Add New Client",
    clientName: "Client Name",
    save: "Save",
    cancel: "Cancel",
    websites: "Websites",
    addWebsite: "Add Website",
    websiteUrl: "Website URL",
    keywords: "Keywords",
    advertorials: "SEO Advertorials",
    reports: "Reports",
    addKeyword: "Add Keyword",
    keywordTerm: "Keyword",
    position: "Position",
    searchVolume: "Search Volume",
    lastChecked: "Last Checked",
    checkPosition: "Check Data",
    addAdvertorial: "Add Advertorial",
    title: "Title",
    url: "URL",
    publishDate: "Publish Date",
    apiSettings: "DataForSEO API Settings",
    apiLogin: "API Login",
    apiPassword: "API Password",
    dataManagement: "Data Management",
    exportData: "Export Master JSON",
    importData: "Import Master JSON",
    language: "Language",
    noData: "No data available.",
    manualEntry: "Manual Entry",
    updatePos: "Update"
  },
  ro: {
    loginTitle: "Acces Corporativ",
    accessCode: "Cod de Acces",
    loginBtn: "Intră în Platformă",
    invalidCode: "Cod invalid. Încearcă din nou.",
    dashboard: "Panou de Control",
    clients: "Clienți",
    settings: "Setări",
    logout: "Deconectare",
    totalClients: "Total Clienți",
    totalWebsites: "Website-uri Urmărite",
    totalKeywords: "Cuvinte Cheie",
    recentActivity: "Prezentare Platformă",
    addClient: "Adaugă Client Nou",
    clientName: "Nume Client",
    save: "Salvează",
    cancel: "Anulează",
    websites: "Website-uri",
    addWebsite: "Adaugă Website",
    websiteUrl: "URL Website",
    keywords: "Cuvinte Cheie",
    advertorials: "Advertoriale SEO",
    reports: "Rapoarte",
    addKeyword: "Adaugă Cuvânt Cheie",
    keywordTerm: "Cuvânt Cheie",
    position: "Poziție",
    searchVolume: "Volum Căutări",
    lastChecked: "Ultima Verificare",
    checkPosition: "Verifică Date",
    addAdvertorial: "Adaugă Advertorial",
    title: "Titlu",
    url: "URL",
    publishDate: "Data Publicării",
    apiSettings: "Setări API DataForSEO",
    apiLogin: "Login API",
    apiPassword: "Parolă API",
    dataManagement: "Management Date",
    exportData: "Exportă JSON Master",
    importData: "Importă JSON Master",
    language: "Limbă",
    noData: "Nu există date.",
    manualEntry: "Introducere Manuală",
    updatePos: "Actualizează"
  }
};